import TriviaV2Service from "@/services/triviaV2Service";
import store from "@/store";

export async function userAuthenticate(to, from, next) {
    const encryptedMsisdn = to.query['e-msisdn'];
    const msisdnParam = to.query.msisdn;
    const campaignId = to.query.campaignId;
    const token = localStorage.getItem('token');

    if (campaignId) store.commit('setCampaignId', campaignId);

    if (encryptedMsisdn) return await encryptedMsisdnAuth(encryptedMsisdn, next);
    if (msisdnParam) return await msisdnAuth(msisdnParam, next);

    if (store.state.user) return next();
    if (token) return await tokenAuth(next);

    window.location.href = 'https://goalgambit.co.za/';
    return next(false);
}

async function msisdnAuth(msisdn, next) {
    try {
        const auth = await TriviaV2Service.sessionLogin(msisdn);
        if (auth && auth.token) {
            await hydrateUser(auth.msisdn || msisdn);
            store.commit('setIsLoading', false);
            return next({name: 'LandingPage'});
        }
    } catch (e) {
        console.error('msisdn session login failed:', e);
    }
    store.commit('setIsLoading', false);
    return next();
}

async function tokenAuth(next) {
    const session = await TriviaV2Service.getSession();
    if (session && session.authenticated) {
        await hydrateUser(session.msisdn && session.msisdn.msisdn);
        store.commit('setIsLoading', false);
        return next({name: 'LandingPage'});
    }
    localStorage.removeItem('token');
    store.commit('setToken', undefined);
    store.commit('setIsLoading', false);
    return next();
}

async function encryptedMsisdnAuth(encryptedMsisdn, next) {
    const auth = await TriviaV2Service.decryptMsisdnLogin(encryptedMsisdn);
    store.commit('setIsLoading', false);
    if (auth && auth.token) {
        await hydrateUser(auth.msisdn);
        return next({name: 'LandingPage'});
    }
    return next();
}

async function hydrateUser(msisdn) {
    let state = {};
    try {
        state = (await TriviaV2Service.getUserState()).data || {};
    } catch (e) {
        state = {};
    }
    const user = {
        ...state,
        msisdn,
        username: state.Username != null ? state.Username : (state.username != null ? state.username : null),
    };
    store.commit('setUser', user);
    store.commit('setMsisdn', msisdn);
    store.commit('setCoolDownTimerPopup', false);
}
